import { FC } from "react";

import { menuContext, MenuContextValue } from "./MenuContext";

export const MenuProvider: FC<MenuContextValue> = ({ children, ...props }) => (
  <menuContext.Provider value={props}>{children}</menuContext.Provider>
);
